import { useState } from "react"

export const DashboardState = () => {
    const [isLoader, setIsLoader] = useState(true)
    const [bookingSales, setBookingSales] = useState([])
    const [productSales, setProductSales] = useState([])

    return {
        isLoader: { data: isLoader, set: setIsLoader },
        bookingSales: { data: bookingSales, set: setBookingSales },
        productSales: { data: productSales, set: setProductSales },
    }
}
